/**
 * Seekers Bookings Routes
 *
 * This route serves shows interview requests, (EONC) bookings, and completed contracts for seekers/parents
 *
 *
 * Guards:
 * - requireSeeker: Ensures user is a parent (authentication)
 * - checkParentRegistration: Ensures premium parents have completed address registration
 */
import { RouteConfig } from 'vue-router';
import { requireSeeker } from '@/router/guards/authGuards';
import checkParentRegistration from '@/router/guards/completionGuards';
import combineGuards from '../guards/helpers';

const bookingsRoutes: RouteConfig[] = [
  {
    path: '/bookings',
    name: 'seeker-bookings',
    component: () => import('@/apps/bookings/SeekerBookings.vue'),
    beforeEnter: combineGuards([requireSeeker, checkParentRegistration]),
  },
];

export default bookingsRoutes;
